import DataGrid from '../../../../../table/DataGrid';
import IconTooltipButton from '../../../../../button/IconTooltipButton';

const List = ({ isLoading, list, permissions, onAction }) => {
  const columnsTable = [
    {
      show: false,
      key: 'checkId',
      align: 'left',
      hide: false,
      width: 1,
      label: ''
    },
    {
      show: true,
      key: 'code',
      align: 'center',
      hide: false,
      width: 5,
      label: 'Code'
    },
    {
      show: true,
      key: 'primary',
      align: 'left',
      hide: false,
      width: 200,
      label: 'Name'
    },
    {
      show: true,
      key: 'type',
      className: 'uppercase',
      align: 'center',
      hide: false,
      width: 5,
      label: 'type'
    },
    {
      show: true,
      key: 'levels',
      align: 'center',
      className: 'uppercase',
      hide: false,
      width: 5,
      label: 'levels'
    },
    {
      show: true,
      key: 'actions',
      align: 'center',
      hide: false,
      width: 50,
      label: 'actions'
    }
  ];

  return (
    <DataGrid
      id='levels-periodical-report'
      showSetting={false}
      rowsPerPage={list?.length || 10}
      groupBy={'curriculum'}
      rows={list.map((row) => {
        let firstLevel = '';
        let lastLevel = '';
        if (row.curriculumId) {
          const rowlevels = row?.levels?.map((level) => (level.levelId ? level.levelId : level)) || [];
          const levelsdata = row.curriculumLevels
            ?.filter((level) => rowlevels?.includes(level._id))
            ?.sort((a, b) => a.position - b.position);
          firstLevel = levelsdata[0]?.code;
          lastLevel = levelsdata[levelsdata.length - 1]?.code;
        }

        return {
          ...row,
          levels: (
            <div className='flex flex-col justify-center'>
              {firstLevel && (
                <div className='flex gap-1 items-center justify-center'>
                  <span>{firstLevel}</span>
                  <span>{firstLevel !== lastLevel && ` - ${lastLevel}`}</span>
                </div>
              )}
            </div>
          ),
          primary: (
            <div>
              <p>{row.name}</p>
              <p className='text-xs text-muted-foreground opacity-50'>{row.description}</p>
            </div>
          ),
          actions: (
            <div>
              {permissions['preview'] && (
                <IconTooltipButton
                  title='Preview'
                  icon='expand-alt'
                  onClick={() => onAction('preview', row)}
                />
              )}
              {permissions['updated'] && (
                <IconTooltipButton
                  title='Edit'
                  icon={['fas', 'edit']}
                  onClick={() => onAction('edit', row)}
                />
              )}
              {permissions['deleted'] && (
                <IconTooltipButton
                  title='Delete'
                  icon={['fas', 'trash-alt']}
                  onClick={() => onAction('delete', row)}
                />
              )}
            </div>
          )
        };
      })}
      loading={isLoading}
      columns={[
        // {
        //   show: true,
        //   key: 'checkId',
        //   align: 'center',
        //   hide: false,
        //   width: 15,
        //   label: (
        //     <Checkbox
        //       id={`checkbox-id-subject-assessment-area-header`}
        //       checked={
        //         form?.subject?.length > 0 ? form?.subject?.length === subjectData?.length : false
        //       }
        //       indeterminate={form?.subject?.length > 0 && form?.subject?.length < subjectData?.length}
        //       onChange={(e) => onSelectedAll(e.target.checked)}
        //       color='primary'
        //     />
        //   )
        // },
        ...columnsTable
      ]}
      labelNoRows="You don't have any assessment area yet"
    />
  );
};

export default List;
